module.exports = __webpack_public_path__ + "img/Physical-Protection.1f6144d7.png";